module.exports = __webpack_public_path__ + "c8de4a2d1954e33b03342324d5d1c133.png";